import * as React from "react";
import { useTranslation } from "react-i18next";

export const Copyright = (): JSX.Element => {
    const { t } = useTranslation();
    const year = new Date().getFullYear();
    return <div className="copyright">{t("copyright", { year })}</div>;
};
